import api from './api';

async function calculate(body) {
  return api.post('/calculator', body);
}

export { calculate };